import type {
  StructureWithIssueCountsBase,
  IssueCount,
} from "../../data/useIssueCounts";
import { formatInt } from "../../lib/utils";
import Table from "react-bootstrap/Table";
import ResponsiblePersons from "../ResponsiblePersons";
import { Link } from "react-router-dom";

const getBiggestIssue = (issueCounts: IssueCount[]): IssueCount => {
  let largestIssue: IssueCount = { issue: "(none)", theme: "(none)", count: 0 };
  for (const issue of issueCounts) {
    if (issue.count > largestIssue.count) {
      largestIssue = issue;
    }
  }
  return largestIssue;
};

const getBiggestTheme = (
  issueCounts: IssueCount[],
): { theme: string; count: number } => {
  const themeCounts: Record<string, number> = {};
  for (const issue of issueCounts) {
    if (themeCounts[issue.theme] == null) {
      themeCounts[issue.theme] = issue.count;
    } else {
      themeCounts[issue.theme] += issue.count;
    }
  }
  let biggestTheme: { theme: string; count: number } = {
    theme: "(none)",
    count: 0,
  };
  for (const [theme, count] of Object.entries(themeCounts)) {
    if (count > biggestTheme.count) {
      biggestTheme = { theme, count };
    }
  }
  return biggestTheme;
};

interface ChildIssueTableProps {
  children: StructureWithIssueCountsBase[];
}

export default function ChildIssueTable({
  children,
}: ChildIssueTableProps): JSX.Element {
  return (
    <Table responsive striped className="break-before">
      <thead>
        <tr>
          <th />
          <th className="text-center">VD Counts</th>
          <th>Biggest theme</th>
          <th className="numcell">Count of theme</th>
          <th>Biggest single issue</th>
          <th className="numcell">Count of issue</th>
        </tr>
      </thead>
      <tbody>
        {children.map((c) => {
          const biggestIssue = getBiggestIssue(c.microtargeting.issuecounts);
          const biggestTheme = getBiggestTheme(c.microtargeting.issuecounts);
          return (
            <tr key={c.code}>
              {c.type !== "votingdistrict" ? (
                <td>
                  <Link to={`/${c.type}/${c.code}/issues`}>{c.name}</Link>{" "}
                  <ResponsiblePersons persons={c.responsiblePersons} />
                </td>
              ) : (
                <td>{c.name}</td>
              )}
              <td className="text-center">{`${formatInt(c.counts.filtered)} of ${formatInt(c.counts.total)}`}</td>
              <td>{biggestTheme.theme}</td>
              <td className="numcell">{formatInt(biggestTheme.count)}</td>
              <td>
                {biggestIssue.theme} - {biggestIssue.issue}
              </td>
              <td className="numcell">{formatInt(biggestIssue.count)}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
